// import { AxiosResponse } from 'axios'
import {
  ApiPatientClient,
  ApiRequest,
  ApiResponse,
  ApiMethod
} from 'service/protocols/api-patient/api-patient-client'
import {
  IApiPatientRepository,
  RepositoryRequest
} from 'service/protocols/api-patient/api-patient-repository'

export class ApiPatientRepository<Model = any>
  implements IApiPatientRepository<Model>
{
  constructor(private readonly apiPatientClient: ApiPatientClient<Model>) {}

  async get(data: RepositoryRequest): Promise<ApiResponse<Model>> {
    return await this.apiPatientClient.request({
      ...data,
      method: ApiMethod.GET
    } as ApiRequest)
  }

  async post(data: RepositoryRequest): Promise<ApiResponse<Model>> {
    const request = await this.apiPatientClient.request({
      ...data,
      method: ApiMethod.POST
    } as ApiRequest)

    return request
  }

  async put(data: RepositoryRequest): Promise<ApiResponse<Model>> {
    return await this.apiPatientClient.request({
      ...data,
      method: ApiMethod.PUT
    } as ApiRequest)
  }

  delete(data: RepositoryRequest): Promise<ApiResponse<Model>> {
    return this.apiPatientClient.request({
      ...data,
      method: ApiMethod.DELETE
    } as ApiRequest)
  }
}
